import React from 'react';
import { connect } from 'react-redux';
import { DBIntFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class StrengthPinchGrip extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.textfield_row}>
                    <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Strength - Pinch Grip' />
                    <label className={styles.textarea_label}>Pinch Grip</label>
                    <label className={styles.r}>{this.props.ravg ? 'Avg: ' + this.props.ravg.toFixed(2) : ''}</label>
                    <span className={styles.c} />
                    <label className={styles.l}>{this.props.lavg ? 'Avg: ' + this.props.lavg.toFixed(2) : ''}</label>
                </div>

                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel}>Trial 1</label>
                    <DBIntFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STPINCHGRIP1R'
                        className={styles.r}
                    />
                    <span className={styles.c} >
                        <span className={styles.prev_wrapper}>
                            {this.props.prev1R}
                        </span>
                    </span>
                    <DBIntFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STPINCHGRIP1L'
                        className={styles.l}
                    />
                    <span className={styles.prev_wrapper}>
                        {this.props.prev1L}
                    </span>
                </div>

                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel}>Trial 2</label>
                    <DBIntFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STPINCHGRIP2R'
                        className={styles.r}
                    />
                    <span className={styles.c} >
                        <span className={styles.prev_wrapper}>
                            {this.props.prev2R}
                        </span>
                    </span>
                    <DBIntFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STPINCHGRIP2L'
                        className={styles.l}
                    />
                    <span className={styles.prev_wrapper}>
                        {this.props.prev2L}
                    </span>
                </div>

                <div className={styles.textfield_row}>
                    <span className={styles.flag} />
                    <label className={styles.sublabel}>Trial 3</label>
                    <DBIntFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STPINCHGRIP3R'
                        className={styles.r}
                    />
                    <span className={styles.c} >
                        <span className={styles.prev_wrapper}>
                            {this.props.prev3R}
                        </span>
                    </span>
                    <DBIntFieldObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESTR'
                        entityKeyColumn='STNO'
                        entityKeyValue={this.props.stno}
                        field='STPINCHGRIP3L'
                        className={styles.l}
                    />
                    <span className={styles.prev_wrapper}>
                        {this.props.prev3L}
                    </span>
                </div>
            </div >
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let stno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESTR)
        .find(key => (state.entities.notes.PTOBJECTIVESTR[key].STEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVESTR[key].STNTNO === pk && noteType !== 1)));

    let ravg = undefined;
    let lavg = undefined;

    if (state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP1R &&
        state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP2R &&
        state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP3R) {
        ravg = (state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP1R +
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP2R +
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP3R) / 3;
    }

    if (state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP1L &&
        state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP2L &&
        state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP3L) {
        lavg = (state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP1L +
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP2L +
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP3L) / 3;
    }

    let prev1R = '';
    let prev1L = '';
    let prev2R = '';
    let prev2L = '';
    let prev3R = '';
    let prev3L = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVESTRPREV[pk]) {
        prev1R = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPINCHGRIP1R'];
        prev1L = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPINCHGRIP1L'];
        prev2R = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPINCHGRIP2R'];
        prev2L = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPINCHGRIP2L'];
        prev3R = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPINCHGRIP3R'];
        prev3L = state.entities.notes.PTOBJECTIVESTRPREV[pk]['STPINCHGRIP3L'];
    }

    return {
        noteId: noteId,
        stno: stno,
        flagged: state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP1R ||
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP1L ||
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP2R ||
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP2L ||
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP3R ||
            state.entities.notes.PTOBJECTIVESTR[stno].STPINCHGRIP3L
            ? true : false,
        ravg: ravg,
        lavg: lavg,
        prev1R,
        prev1L,
        prev2R,
        prev2L,
        prev3R,
        prev3L,

    };
}

const connectedStrengthPinchGrip = connect(mapStateToProps)(StrengthPinchGrip);
export { connectedStrengthPinchGrip as StrengthPinchGrip };


